import { render, staticRenderFns } from "./AppealHistory.vue?vue&type=template&id=36bbdc5b"
import script from "./AppealHistory.vue?vue&type=script&lang=js"
export * from "./AppealHistory.vue?vue&type=script&lang=js"
import style0 from "./AppealHistory.vue?vue&type=style&index=0&id=36bbdc5b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VAlert,VBtn,VDataTable,VIcon,VOverlay,VProgressCircular})
